import { createApp } from "vue";
import { createPinia } from 'pinia'
import ElementPlus from "element-plus";
import ru from "element-plus/es/locale/lang/ru";
import "dayjs/locale/ru";
import "element-plus/dist/index.css";
import router from "./router";
import VueTheMask from "vue-the-mask";
import App from "./App/App.vue";


const pinia = createPinia()

const app = createApp(App);

app.use(ElementPlus, {
  locale: ru,
});
app.use(router);
app.use(VueTheMask);

app.directive('cancelReadOnly', (el) => {
  const input = el.querySelector('.el-input__inner');
  input.removeAttribute('readonly');
})

app.use(pinia)
app.mount("#app");
